module.exports = {
	"genre": {
		"genre-id-1": "Verschiedenes",
		"genre-id-2": "Blues/Country/Folk",
		"genre-id-3": "Blues",
		"genre-id-4": "Country",
		"genre-id-5": "Folk",
		"genre-id-6": "Französischer Chanson",
		"genre-id-7": "Interpret:innen des Französischen Chanson",
		"genre-id-8": "Französischer Retro-Chanson",
		"genre-id-9": "Französischer Rock",
		"genre-id-10": "Klassik",
		"genre-id-11": "Elektronische Musik oder Musique concrète",
		"genre-id-12": "Musique concrète",
		"genre-id-13": "Elektronische Musik",
		"genre-id-14": "Minimal Music",
		"genre-id-15": "Französische Mélodies und Kunstlieder",
		"genre-id-16": "Kunstlieder (Deutschland)",
		"genre-id-17": "Kunstlieder",
		"genre-id-18": "Mélodies",
		"genre-id-19": "Mélodies (England)",
		"genre-id-20": "Mélodies (Nordeuropa)",
		"genre-id-21": "Mélodies (Frankreich)",
		"genre-id-22": "Instrumentalmusik",
		"genre-id-23": "Sonstige Instrumente",
		"genre-id-24": "Konzerte für Tasteninstrumente",
		"genre-id-25": "Violinkonzerte",
		"genre-id-26": "Cellokonzerte",
		"genre-id-27": "Kammermusik",
		"genre-id-28": "Andere Formationen",
		"genre-id-29": "Andere Soloinstrumente",
		"genre-id-30": "Klaviersolo",
		"genre-id-31": "Quartette",
		"genre-id-32": "Quintette",
		"genre-id-33": "Duette",
		"genre-id-34": "Trios",
		"genre-id-35": "Geigensolo",
		"genre-id-36": "Cellosolo",
		"genre-id-37": "Symphonieorchester",
		"genre-id-38": "Ballett",
		"genre-id-39": "Intermezzi",
		"genre-id-40": "Filmmusik",
		"genre-id-41": "Ouvertüren",
		"genre-id-42": "Sinfonische Dichtung",
		"genre-id-43": "Sinfonien",
		"genre-id-44": "Vokalmusik (weltlich und geistlich)",
		"genre-id-45": "Kantaten (weltlich)",
		"genre-id-46": "Chorwerke (für den Chor)",
		"genre-id-47": "Musik für Vokalensembles",
		"genre-id-48": "Weltliche Oratorien",
		"genre-id-49": "Gesangsrezitale",
		"genre-id-50": "Geistliche Vokalmusik",
		"genre-id-51": "Geistliche Kantaten",
		"genre-id-52": "Geistliche Chormusik",
		"genre-id-53": "Messen, Passionen, Requiems",
		"genre-id-54": "Geistliche Oratorien",
		"genre-id-55": "Oper",
		"genre-id-56": "Opernauszüge",
		"genre-id-57": "Gesamtaufnahmen von Opern",
		"genre-id-58": "Operette",
		"genre-id-59": "Hörbücher",
		"genre-id-60": "Pädagogik",
		"genre-id-61": "Historische Dokumente",
		"genre-id-62": "Humor",
		"genre-id-63": "Literatur",
		"genre-id-64": "Electronic",
		"genre-id-65": "Ambient",
		"genre-id-66": "Downtempo",
		"genre-id-67": "Drum and Bass",
		"genre-id-68": "House",
		"genre-id-69": "Lounge",
		"genre-id-70": "Techno",
		"genre-id-71": "Trance",
		"genre-id-72": "Trip-Hop",
		"genre-id-73": "Kinder",
		"genre-id-74": "Akkordeon",
		"genre-id-75": "Märchen und Kinderreime",
		"genre-id-76": "Bildung",
		"genre-id-77": "Karaoke",
		"genre-id-78": "Militärmusik",
		"genre-id-79": "Entspannung",
		"genre-id-80": "Jazz",
		"genre-id-81": "Bebop",
		"genre-id-82": "Cool Jazz",
		"genre-id-83": "Free Jazz & Avantgarde",
		"genre-id-84": "Gospel",
		"genre-id-85": "Modern Jazz",
		"genre-id-86": "Jazz Fusion & Jazzrock",
		"genre-id-87": "Gypsy-Jazz",
		"genre-id-88": "Klassischer Jazz & New-Orleans-Jazz",
		"genre-id-89": "Jazzgesang",
		"genre-id-90": "Latin Jazz",
		"genre-id-91": "Soundtracks",
		"genre-id-92": "Original Soundtrack",
		"genre-id-93": "Musical",
		"genre-id-94": "World Music",
		"genre-id-95": "Afrikanische Musik",
		"genre-id-96": "Afrobeat",
		"genre-id-97": "Asiatische Musik",
		"genre-id-98": "Brasilianische Musik",
		"genre-id-99": "Keltische Musik",
		"genre-id-100": "Osteuropäische Musik",
		"genre-id-101": "Fado",
		"genre-id-102": "Flamenco",
		"genre-id-103": "Ethnische Musik",
		"genre-id-104": "Indische Musik",
		"genre-id-105": "Orientalische Musik",
		"genre-id-106": "Raï",
		"genre-id-107": "Salsa",
		"genre-id-108": "Tango",
		"genre-id-109": "Weltmusik",
		"genre-id-110": "Jiddische Musik & Klezmer",
		"genre-id-111": "Zouk & Musik von den Antillen",
		"genre-id-112": "Pop/Rock",
		"genre-id-113": "Alternativ und Indie",
		"genre-id-114": "Crooner",
		"genre-id-115": "Hard Rock",
		"genre-id-116": "Metal",
		"genre-id-117": "Pop",
		"genre-id-118": "Punk - New Wave",
		"genre-id-119": "Rock",
		"genre-id-120": "Progressive Rock",
		"genre-id-121": "Rockabilly",
		"genre-id-122": "Internationales Varieté",
		"genre-id-123": "Reggae",
		"genre-id-124": "Dancehall",
		"genre-id-125": "Dub",
		"genre-id-126": "Ska & Rocksteady",
		"genre-id-127": "Soul/Funk/R&B",
		"genre-id-128": "Acid Jazz",
		"genre-id-129": "Dance",
		"genre-id-130": "Disco",
		"genre-id-131": "Funk",
		"genre-id-132": "R&B",
		"genre-id-133": "Hip-Hop/Rap",
		"genre-id-134": "Soul",
		"genre-id-135": "Operette",
		"genre-id-137": "Trompetenkonzerte",
		"genre-id-138": "Bläserkonzerte",
		"genre-id-139": "Crossover",
		"genre-id-140": "Historische Dokumente",
		"genre-id-141": "New Age",
		"genre-id-142": "Verschiedenes",
		"genre-id-144": "Crossover",
		"genre-id-145": "Dixieland",
		"genre-id-146": "Ragtime",
		"genre-id-147": "TV-Serien",
		"genre-id-148": "Computerspiele",
		"genre-id-149": "Latin",
		"genre-id-150": "Nordamerikanische Musik",
		"genre-id-151": "Europäische Musik",
		"genre-id-152": "Musik der Roma",
		"genre-id-153": "Traditionelle Musik",
		"genre-id-154": "Musik aus den Maghreb-Staaten",
		"genre-id-155": "Russische Musik",
		"genre-id-156": "Türkische Musik",
		"genre-id-157": "Indie-Pop",
		"genre-id-158": "Bawdy songs",
		"genre-id-159": "Weihnachtsmusik",
		"genre-id-160": "Deutsche Musik",
		"genre-id-161": "Schottische Musik",
		"genre-id-162": "Spanische Musik",
		"genre-id-163": "Griechische Musik",
		"genre-id-164": "Irische Musik",
		"genre-id-165": "Italienische Musik",
		"genre-id-166": "Portugiesische Musik",
		"genre-id-167": "Kinder",
		"genre-id-176": "Weltliche Vokalmusik",
		"genre-id-173": "Schlager",
		"genre-id-171": "Stimmungsmusik",
		"genre-id-172": "Volksmusik",
		"genre-id-174": "Irisch-keltische Musik",
		"genre-id-175": "Irische Popmusik",
		"genre-id-168": "Schweizer Volksmusik",
		"genre-id-178": "Deutsche Musik",
		"genre-id-177": "Englische Musik",
		"genre-id-170": "Französische Musik",
		"genre-id-179": "Niederländische Musik",
		"genre-id-180": "Bolero",
		"genre-id-181": "Urban Latino",
		"genre-id-182": "Reggaeton",
		"genre-id-183": "MPB (Música Popular Brasileira)",
		"genre-id-184": "Bossa Nova",
		"genre-id-185": "Samba",
		"genre-id-186": "Forró",
		"genre-id-187": "Pagode",
		"genre-id-188": "Rio Funk",
		"genre-id-189": "Música Sertaneja",
		"genre-id-190": "Japanische Musik",
		"genre-id-191": "J-Pop",
		"genre-id-192": "Traditionelle japanische Musik",
		"genre-id-193": "Koreanische Musik",
		"genre-id-194": "K-Pop",
		"genre-id-195": "Traditionelle koreanische Musik",
		"genre-id-196": "Anime/Videospiele",
		"genre-id-197": "Anime"
	},
	"article-cat": {
		"article-cat-2": "-- ARCHIV --",
		"article-cat-4": "Begegnungen",
		"article-cat-5": "-- ARCHIVE --",
		"article-cat-7": "Auf der Bühne",
		"article-cat-8": "Nominierungen und Auszeichnungen",
		"article-cat-10": "In der Presse",
		"article-cat-22": "In Gedenken an...",
		"article-cat-51": "Diskografie",
		"article-cat-53": "Bibliografie",
		"article-cat-54": "Portraits",
		"article-cat-97": "Aktuelles",
		"article-cat-98": "Hauptrubriken",
		"article-cat-100": "Gewerbe",
		"article-cat-101": "Neuheiten",
		"article-cat-117": "JazzNews",
		"article-cat-122": "Aktuelles",
		"article-cat-189": "Interview",
		"article-cat-197": "Vergleichendes Hören",
		"article-cat-199": "Begegnungen",
		"article-cat-209": "Singende Erinnerungen",
		"article-cat-226": "Cave Canem",
		"article-cat-227": "Fortissimo",
		"article-cat-229": "Kannst du?",
		"article-cat-238": "Magazin: Rezensionen",
		"article-cat-252": "Callassotherapy",
		"article-cat-260": "Der Symphoman",
		"article-cat-267": "Begegnungen",
		"article-cat-279": "Konzerte",
		"article-cat-286": "Vertraulich",
		"article-cat-287": "Agenda",
		"article-cat-293": "Events",
		"article-cat-295": "Konzerte und Tourneen",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "Auf dem Prüfstand",
		"article-cat-299": "Praktisches",
		"article-cat-301": "Aktuelles",
		"article-cat-302": "Herausragende Tonaufnahmen",
		"article-cat-303": "Die Zauberer des Klangs",
		"article-cat-304": "Trax",
		"article-cat-305": "Ohrwürmer",
		"article-cat-306": "Vox pop",
		"article-cat-311": "Berliner Philharmoniker",
		"article-cat-312": "André Tubeuf: Erinnerungen und Landschaften",
		"article-cat-315": "François Hudry: Cum grano salis",
		"article-cat-316": "Qibuz Klassik",
		"article-cat-318": "Redaktionelle Beiträge",
		"article-cat-319": "Qobuz in",
		"article-cat-320": "Marseille",
		"article-cat-321": "Festival Paris Baroque",
		"article-cat-322": "Die Hi-Fi-Verrückten",
		"article-cat-323": "Rennes",
		"article-cat-324": "Redaktionelle Beiträge",
		"article-cat-325": "Qibuz",
		"article-cat-326": "Redaktionelle Beiträge von Jean-Michel Proust",
		"article-cat-327": "Jean-Michel Proust: Neuheiten des Monats",
		"article-cat-328": "Qibuz Montag",
		"article-cat-329": "Lille",
		"article-cat-330": "Yes Masters!",
		"article-cat-331": "Die Qobuz Minute",
		"article-cat-332": "Modern",
		"article-cat-333": "Newsletter",
		"article-cat-334": "Wöchentlicher Newsletter",
		"article-cat-335": "Newsletter mit aktuellen Angeboten",
		"article-cat-336": "Hi-Fi-Newsletter",
		"article-cat-337": "Klassik-Newsletter",
		"article-cat-339": "Electronic-Newsletter",
		"article-cat-340": "Newsletter für Kinder",
		"article-cat-341": "Hörbuch-Newsletter",
		"article-cat-342": "Audio-HD kompatible Smartphones",
		"article-cat-343": "Französischer Chanson-Newsletter",
		"article-cat-344": "France Musique",
		"article-cat-345": "Moderner Stil",
		"article-cat-347": "Verschiedenes-Newsletter",
		"article-cat-350": "Auf Englisch",
		"article-cat-351": "Auf Deutsch",
		"article-cat-352": "Auf Niederländisch",
		"article-cat-353": "Auf Englisch",
		"article-cat-354": "Auf Deutsch",
		"article-cat-355": "Auf Niederländisch",
		"article-cat-356": "Auf Niederländisch",
		"article-cat-357": "Auf Deutsch",
		"article-cat-358": "Auf Englisch",
		"article-cat-359": "Vieux Sequins et Vieilles Cuirasses",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "Tutorials",
		"article-cat-362": "Klassik-Neuheiten",
		"article-cat-363": "Qobuz Studio",
		"article-cat-364": "Qobuz Studio",
		"article-cat-365": "Aktuelles",
		"article-cat-368": "Archive",
		"article-cat-369": "Qobuz Chef",
		"article-cat-370": "One Cover / One Word"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiDe.json
// module id = 557
// module chunks = 0